export const ROUTES = {
	HOME: "/",
	GLOBAL_INVENTORY_REPORT: "/global-inventory-report",
	TEAM_SETTINGS: "/team-settings",
	MATTERS: "/matters",
	VARIABLE_QUOTA_LEDGER: "/case-efficiency-ledger",
	BASIC_SETTINGS: "/basic-settings",
	ADVANCED_SETTINGS: "/advanced-settings"
};
